import { memo as Memo, useCallback } from 'react';

//* Components
import CustomLink from '@/components/global/CustomLink';

const EditorContent = Memo(({ data }) => {
	const styleBuilder = useCallback((marks, text, key) => {
		let newClass = '';

		for (let i = 0; i < marks.length; i++) {
			const type = marks[i].type;
			newClass += type === 'bold' ? ` font-medium` : ` font-${type}`;
		}

		return (
			<span
				key={key}
				className={newClass}>
				{text}
			</span>
		);
	}, []);

	const builder = useCallback((content) => {
		return content.map((item, key) => {
			if (item.nodeType === 'text') {
				return styleBuilder(item.marks, item.value, key);
			}

			if (/^heading-[1-6]$/.test(item.nodeType)) {
				const HeadingTag = `h${item.nodeType.split('-')[1]}`;
				return (
					<HeadingTag
						key={key}
						className={`p-m font-poppins font-light text`}>
						{builder(item.content)}
					</HeadingTag>
				);
			}

			if (item.nodeType === 'paragraph') {
				return (
					<p
						key={key}
						className={`p-m font-poppins font-light text`}>
						{builder(item.content)}
					</p>
				);
			}

			if (item.nodeType === 'hr') {
				return <hr key={key} />;
			}

			if (item.nodeType === 'unordered-list' || item.nodeType === 'ordered-list') {
				return (
					<ul key={key}>
						{item.content.map((itemList, keyList) => {
							return (
								<li
									key={keyList}
									className={`p-m font-poppins font-regular list`}>
									{`${item.nodeType === 'unordered-list' ? `${keyList + 1})` : '• '}`}&nbsp;{' '}
									{builder(itemList.content)}
								</li>
							);
						})}
					</ul>
				);
			}

			if (item.nodeType === 'hyperlink') {
				return (
					<CustomLink
						key={key}
						external
						url={item.data.uri}
						className={`crCircle link`}>
						{builder(item.content)}
					</CustomLink>
				);
			}
		});
	}, []);

	return <div className={'textCont'}>{builder(data.content.content)}</div>;
});

export default EditorContent;
